import { useLayoutEffect, useRef, useState } from 'react';

const useContextMenu = (initialPosition = { top: 0, left: 0 }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState(initialPosition);
  const [clientPosition, setClientPosition] = useState({ top: 0, left: 0 });
  const menuRef = useRef(null);

  const openContextMenu = (event = undefined) => {
    event?.preventDefault();
    const { clientY: y, clientX: x } = event ?? { y: 0, x: 0 };

    setClientPosition({ top: y, left: x });
    setMenuOpen(true);
  };

  useLayoutEffect(() => {
    if (menuOpen && menuRef.current) {
      const menuHeight = menuRef.current.offsetHeight;
      const screenHeight = window.innerHeight;
      const topPosition =
        initialPosition.top + clientPosition.top + menuHeight > screenHeight
          ? menuPosition.top - menuHeight + 40
          : menuPosition.top + initialPosition.top;

      setMenuPosition((prev) => ({ ...prev, top: topPosition }));
    }
  }, [menuOpen]);

  const closeContextMenu = () => {
    setMenuOpen(false);
    setMenuPosition({ top: 0, left: 0 });
  };

  return [menuOpen, menuPosition, openContextMenu, closeContextMenu, menuRef];
};

export default useContextMenu;
